// extracted by mini-css-extract-plugin
export default {"container":"material-list_container__WMoQB"};